import G from './Getters';
import O from './O';
import { useSelector } from 'react-redux';
import { scale, getPointsFromLs, distance } from './Geometry';

const __custom = "__custom";
function getAtnHeight(atn){
  return atn.height;
}


const colors = [
  "royalblue",
  "green"
]

export default function ImageSetAnnotationOverlay({imageId}){

  let atns = useSelector(state => G.getAnnotationsByImageId(state,imageId));
  let image = useSelector(state => G.getImage(state,imageId));
  let {height} = image;
  let lsList = atns.filter(x => x.ls);


  //const width = 50;
  

  const width=50;
  let pathRects = lsList.map(atn => getPointsFromLs(atn.ls, atn.height).map(scale(width)));


  let diagonalLengths = pathRects.map(rect => {
    return Math.max( ...rect.map(rp => distance(rp,rect[0])) )
  })

  let dWithIndex = diagonalLengths.map((dLen,ii) => ([dLen,ii]));

  let sortedD = dWithIndex.sort((a,b) => b[0] - a[0]);

  let top2Indices = sortedD.slice(0,2).map(x => x[1]);



  //let rectPoints = points.map(pp => pp.map(scale(width)));
  


  let paths = pathRects.map(rectPoints => "M " + rectPoints.map(p => p.join(" ")).join(" L ") + " Z");


  let pathsToRender = top2Indices.map(index => paths[index])

  debugger;

  //viewBox="0 0 20 10"
  //
  const strokeWidth = 30/width;
  const viewBox = `0 0 ${width} ${width*height}`
  return (
    <>
    <svg style={{
      //border:'3px solid red'
    }} viewBox={viewBox} class="absolute-cover full-dim">

      {pathsToRender.map((pathD,iiPath) => <path {...{
        d:pathD,
        fill:"transparent",
        stroke:colors[iiPath],//"royalblue",
        strokeWidth:(viewBox ? strokeWidth : 3),
      }}/>)}

    </svg>
    </>
  )




}
